import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import PreVerified from '../../../../../../images/pre_verified.png';
export default class SizeItem extends Component{
  
    render(){
        return (
          <div
            className="size-item"
            style={{
              visibility: this.props.size.US === 888 ? 'hidden' : 'visible'
            }}
          >
            <div 
              className="size-item__pre_perified"
              style={{
                visibility: this.props.sell.pre_verified === 0 ? 'hidden' : 'visible'
              }}
            >
              <KickImage 
                style={{
                  width: '100%',
                  maxWidth: '100%'
                }}
                src={PreVerified} />
            </div>
            <Button onClick={()=>this.props.onSizeSelected(this.props.sell)} className={classnames({'selected':this.props.active})}>
              {
                this.props.isVilla
                  ? this.props.size.cm === undefined ? '' : this.props.size.cm
                  : this.props.size.US === undefined ? '' : this.props.size.US
              }
            </Button>
          </div>
        )
    }
}
SizeItem.propTypes={
    active:PropTypes.bool,
    onSizeSelected:PropTypes.func,
    size:PropTypes.object,
    sell:PropTypes.object
}